<template>
  <div>
    <component :ref="'REF_'+wflowScrnId+'_'+scrnId" :key="wflowScrnId+'_'+scrnId+'_'+Date.now()"
      :is="witchStep"
      :openToggle="true"
      :isWrite="isWrite"
      :isTemplate="false"
      :defaultValue="defaultValue"
      :exeWflowId="exeWflowId"
      :svcCtlogId="svcCtlogId"
      :depth1SvcCtlogId="depth1SvcCtlogId"
      :prcssTypeCd="prcssTypeCd"
      :idcCd="idcCd"
      :svcNo="svcNo"
      :custId="custId"
      :stepCd="stepCd"
      :prcssTrtDataCnctId="prcssTrtDataCnctId"
      :mainPrcssId="mainPrcssId"
      :subPrcssId="subPrcssId"
      :wflowScrnId="wflowScrnId"
      :scrnId="scrnId"
      :mandDataChkYn="mandDataChkYn"
      :sftyChkMandChkYn="sftyChkMandChkYn"
      :sftyChkScrnYn="sftyChkScrnYn"
      :scrnGetApi="scrnGetApi"
      :scrnPostApi="scrnPostApi"
      :scrnPutApi="scrnPutApi"
      :scrnDeleteApi="scrnDeleteApi"
      :ticktId="ticktId"
      :groupTicktId="groupTicktId"
      :ticketInfo="calTicketInfo"
    >{{ isShowTitle ? compTitle : '' }}</component><!--  -->
  </div>
</template>

<script>
import ComponentJSON from "@/assets/json/WrkComponentsJSON.json"

export default {
  props: {
    isShowTitle: {
      type: Boolean,
      default: true,
    },
    compTitle: {
      type: String,
      default: "",
    },
    compNm: {
      type: String,
      default: "",
    },
    defaultValue: {
      type: Object,
      default: () => {},
    },
    exeWflowId: {
      type: String,
      default: ''
    },
    svcCtlogId: {
      type: String,
      defautl: '',
    },
    depth1SvcCtlogId: {
      type: String,
      default: '',
    },
    depth2SvcCtlogId: {
      type: String,
      default: '',
    },
    prcssTypeCd: {
      type: Number,
      default: 0
    },
    idcCd: {
      type: String,
      default: '',
    },
    svcNo: {
      type: String,
      default: '',
    },
    custId: {
      type: String,
      default: '',
    },
    ticktId: {
      type: String,
      default: '',
    },
    groupTicktId: {
      type: String,
      default: ''
    },
    stepCd: {
      type: Number,
      default: 0
    },
    mainPrcssId: {
      type: String,
      default: ''
    },
    subPrcssId: {
      type: String,
      default: ''
    },
    wflowScrnId: {
      type: String,
      default: ''
    },
    scrnId: {
      type: String,
      default: ''
    },
    mandDataChkYn: {
      type: String,
      default: 'N'
    },
    sftyChkMandChkYn: {
      type: String,
      default: 'N'
    },
    sftyChkScrnYn: {
      type: String,
      default: 'N'
    },
    scrnGetApi: {
      type: String,
      default: ''
    },
    scrnPostApi: {
      type: String,
      default: ''
    },
    scrnPutApi: {
      type: String,
      default: ''
    },
    scrnDeleteApi: {
      type: String,
      default: ''
    },
    allTicketList: {
      type: Array,
      default: () => [],
    }
  },
  data() {
    return {
      componentJson: Object.entries(ComponentJSON),
      targetTicketInfo: {},
      isWrite: false,
      prcssTrtDataCnctId: '',
      componentStore: {},
    };
  },
  watch: {
    targetTicketInfo() {
      if (Object.keys(this.targetTicketInfo).length > 0) {
        this.isWrite = false;

        // isWrite 체크
        const ticketInfo = this.targetTicketInfo;

        this.isWrite = ticketInfo.isWrite;
        if (ticketInfo.ticktSttusCd != 2873) {
          this.isWrite = false;
        }

        // 데이터 연결아이디
        const tmpList = this.$store.getters["wflowStore/getExeWflowPrcssTrtDataCnctList"];
        if (tmpList.length == 0) { return ''; }

        var prcssTrtDataCnctId = '';
        const stepCd = this.stepCd; // this.$store.getters['wflowStore/getWwflowCurrentStepCd']; // 단계코드
        tmpList.forEach(tmp => {
          if (tmp.stepCd      != stepCd) return; // 단계코드 비교
          // if (tmp.ticktId     != ticketInfo.ticktId) return; // 티켓아이디 비교
          if (tmp.ticktId     != ticketInfo.groupTicktId) return; // 티켓아이디(그룹티켓아이디) 비교
          if (tmp.mainPrcssId != this.mainPrcssId) return; // 상위공정 비교 
          if (tmp.subPrcssId  != this.subPrcssId) return; // 하위공정 비교 
          if (tmp.wflowScrnId != this.wflowScrnId) return; // 워크플로우화면 비교
          if (tmp.scrnId      != this.scrnId) return; // 화면아이디 비교
          prcssTrtDataCnctId = tmp.prcssTrtDataCnctId;
        });
        //console.log('~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~')
        //console.log('단계: ' + stepCd)
        //console.log('티켓아이디: ' + this.calTicketInfo.ticktId)
        //console.log('상위공정: ' + this.mainPrcssId)
        //console.log('하위공정: ' + this.subPrcssId)
        //console.log('워크플로우화면: ' + this.wflowScrnId)
        //console.log('컴포넌트명: ' + this.compNm + "(" + this.compTitle + ")")
        //console.log('계산된 공정처리연결아이디: ' + prcssTrtDataCnctId)
        //console.log(this)

        this.componentStore = {
          stepCd: stepCd,
          ticktId: this.calTicketInfo.ticktId,
          prcssId: this.prcssId,
          subPrcssId: this.subPrcssId,
          prcssTrtDataCnctId: prcssTrtDataCnctId,
          wflowScrnId: this.wflowScrnId,
          componentName: this.compNm,
          refName: 'REF_' + this.wflowScrnId + '_' + this.scrnId,
          validateFunction: null,
        };
        this.prcssTrtDataCnctId = prcssTrtDataCnctId;
      }
    }
  },
  components: {
    'idc-modal': () => import("@/components/common/IdcModal.vue"),
    // 공통
    'wrk-common-sbst'      : () => import("@/components/listComponents/wrkComponents/wrkProcessComponents/WrkCommonSbst.vue"),
    'wrk-common-file'      : () => import("@/components/listComponents/wrkComponents/wrkProcessComponents/WrkCommonFile.vue"),
    'wrk-common-opinon'      : () => import("@/components/listComponents/wrkComponents/wrkProcessComponents/WrkCommonOpinon.vue"),
    // 등록
    'wrk-order-info'       : () => import("@/components/listComponents/wrkComponents/wrkRegist/WrkOrderInfo.vue"),
    'wrk-cust-info'        : () => import("@/components/listComponents/wrkComponents/wrkRegist/WrkCustInfo.vue"),
    'wrk-admin-info'       : () => import("@/components/listComponents/wrkComponents/wrkRegist/WrkAdminInfo.vue"),
    'wrk-inp-sale-info'    : () => import("@/components/listComponents/wrkComponents/wrkRegist/WrkInpSaleInfo.vue"),
    'wrk-cont-info'        : () => import("@/components/listComponents/wrkComponents/wrkRegist/WrkContInfo.vue"),
    'wrk-service-info'     : () => import("@/components/listComponents/wrkComponents/wrkRegist/WrkServiceInfo.vue"),
    'wrk-sub-service-info' : () => import("@/components/listComponents/wrkComponents/wrkRegist/WrkSubServiceInfo.vue"),
    'wrk-order-reg-info'   : () => import("@/components/listComponents/wrkComponents/wrkRegist/WrkOrderRegInfo.vue"),
    // 접수
    'wrk-receip-info'      : () => import("@/components/listComponents/wrkComponents/wrkReceip/WrkReceipInfo.vue"),
    'wrk-receip-op'        : () => import("@/components/listComponents/wrkComponents/wrkReceip/WrkReceipOp.vue"),
    'wrk-approver'         : () => import("@/components/listComponents/wrkComponents/wrkReceip/WrkApprover.vue"),
    'wrk-forced-comp'      : () => import("@/components/listComponents/wrkComponents/wrkReceip/WrkForcedComp.vue"),
    // 할당
    'wrk-assign-list'      : () => import("@/components/listComponents/wrkComponents/wrkAssignment/WrkAssignList.vue"),
    // 계획
    'wrk-plan-op'          : () => import("@/components/listComponents/wrkComponents/wrkPlan/WrkPlanOp.vue"),
    'wrk-plan-doc'         : () => import("@/components/listComponents/wrkComponents/wrkPlan/WrkPlanDoc.vue"),
    'wrk-ri-rsrv-patch-con' : () => import("@/components/listComponents/wrkComponents/wrkProcessComponents/WrkRiRsrvPatchCon.vue"),
    'wrk-ri-rsrv-rack'     : () => import("@/components/listComponents/wrkComponents/wrkProcessComponents/WrkRiRsrvRack.vue"),
    'wrk-ri-rsrv-cage'     : () => import("@/components/listComponents/wrkComponents/wrkProcessComponents/WrkRiRsrvCage.vue"),
    'wrk-ri-rsrv-oproom'   : () => import("@/components/listComponents/wrkComponents/wrkProcessComponents/WrkRiRsrvOpRoom.vue"),
    'wrk-ri-rsrv-ip'       : () => import("@/components/listComponents/wrkComponents/wrkProcessComponents/WrkRiRsrvIp.vue"),
    'wrk-ri-rsrv-port'     : () => import("@/components/listComponents/wrkComponents/wrkProcessComponents/WrkRiRsrvPort.vue"),
    'wrk-ri-rsrv-cbtpa'    : () => import("@/components/listComponents/wrkComponents/wrkProcessComponents/WrkRiRsrvCbtpa.vue"),
    'config-plan'          : () => import("@/components/listComponents/wrkComponents/wrkPlan/ConfigPlan.vue"),
    'config-result'        : () => import("@/components/listComponents/wrkComponents/wrkPlan/ConfigResult.vue"),
    'wrk-risk-check'       : () => import("@/components/listComponents/wrkComponents/wrkPlan/WrkRiskCheck.vue"),
    'wrk-pms-doc'          : () => import("@/components/listComponents/wrkComponents/wrkPlan/WrkPmsDoc.vue"),
    // 'wrk-reg-docs'      : () => import("@/components/listComponents/wrkComponents/wrkPlan/WrkRegDocs.vue"),
    'wrk-sfty-edu-evdn-dat': () => import("@/components/listComponents/wrkComponents/wrkProcessComponents/WrkSftyEduEvdnDat.vue"),
    'wrk-inot-prsn-list'   : () => import("@/components/listComponents/wrkComponents/wrkProcessComponents/WrkInotPrsnList.vue"),
    'msp-server-table'     : () => import("@/components/listComponents/wrkComponents/wrkProcessComponents/MspServerTable.vue"),
    'msp-net-table'        : () => import("@/components/listComponents/wrkComponents/wrkProcessComponents/MspNetTable.vue"),
    // 승인
    'wrk-app-list'         : () => import("@/components/listComponents/wrkComponents/wrkApprove/WrkAppList.vue"),
    'wrk-app-op'           : () => import("@/components/listComponents/wrkComponents/wrkApprove/WrkAppOp.vue"),
    // 수행
    'wrk-conduct-date'     : () => import("@/components/listComponents/wrkComponents/wrkConduct/WrkConductDate.vue"),
    'wrk-conduct-info'        : () => import("@/components/listComponents/wrkComponents/wrkConduct/WrkConductInfo.vue"),
    'wrk-conduct-op'       : () => import("@/components/listComponents/wrkComponents/wrkConduct/WrkConductOp.vue"),
    'wrk-conduct-check'    : () => import("@/components/listComponents/wrkComponents/wrkConduct/WrkConductCheck.vue"),
    'wrk-popup-1'          : () => import("@/components/listComponents/wrkComponents/wrkConduct/WrkPopup1.vue"),
    'wrk-popup-2'          : () => import("@/components/listComponents/wrkComponents/wrkConduct/WrkPopup2.vue"),
    'wrk-popup-3'          : () => import("@/components/listComponents/wrkComponents/wrkConduct/WrkPopup3.vue"),
    'wrk-popup-4'          : () => import("@/components/listComponents/wrkComponents/wrkConduct/WrkPopup4.vue"),
    // 완료
    'wrk-complete-list'    : () => import("@/components/listComponents/wrkComponents/wrkComplete/WrkCompleteList.vue"),

    // 안전관리라고 추가된 부분
	  // 등록
    'basic-info-regist'    : () => import("@/components/listComponents/safetyManageComponents/safetyRegist/BasicInfoRegist.vue"),
    'period-info'          : () => import("@/components/listComponents/safetyManageComponents/safetyRegist/PeriodInfo.vue"),
    'product-info-regist'  : () => import("@/components/listComponents/safetyManageComponents/safetyRegist/ProductInfoRegist.vue"),
    'safety-basic-info'    : () => import("@/components/listComponents/safetyManageComponents/safetyRegist/BasicInfo.vue"),
    'safety-product-info'  : () => import("@/components/listComponents/safetyManageComponents/safetyRegist/ProductInfo.vue"),
	  'const-receipt-order'  : () => import("@/components/listComponents/safetyManageComponents/safetyRegist/ConstReceiptOrder.vue"),
    'regist-type'          : () => import("@/components/listComponents/safetyManageComponents/safetyRegist/RegistType.vue"),
    'sr-info'              : () => import("@/components/listComponents/safetyManageComponents/safetyRegist/SrInfo.vue"),
    'sr-request-group'     : () => import("@/components/listComponents/safetyManageComponents/safetyRegist/SrRequestGroup.vue"),
    'sr-rqt-reg-info'      : () => import("@/components/listComponents/safetyManageComponents/safetyRegist/SrRqtRegInfo.vue"),
	  // 접수
	  'receipt-basic-info'   : () => import("@/components/listComponents/safetyManageComponents/safetyReceipt/ReceiptBasicInfo.vue"),
	  'select-idc-list'      : () => import("@/components/listComponents/safetyManageComponents/safetyReceipt/SelectIdcList.vue"),
	  'approver-info'        : () => import("@/components/listComponents/safetyManageComponents/safetyReceipt/ApproverInfo.vue"),
	  // 할당
	  'safety-assign-list'   : () => import("@/components/listComponents/safetyManageComponents/safetyAssignment/SafetyAssignList.vue"),
	  // 계획
	  'safety-reg-plan-doc'  : () => import("@/components/listComponents/safetyManageComponents/safetyPlan/SafetyRegPlanDoc.vue"),
    'safety-write-plan-doc': () => import("@/components/listComponents/safetyManageComponents/safetyPlan/SafetyWritePlanDoc.vue"),
    'wrk-rqt-reg'          : () => import("@/components/listComponents/safetyManageComponents/safetyPlan/WrkRqtReg.vue"),
    'safety-wrk-rqt-reg'   : () => import("@/components/listComponents/safetyManageComponents/safetyPlan/SafetyWrkRqtReg.vue"),
    'wrk-plan-section2'    : () => import("@/components/listComponents/safetyManageComponents/safetyPlan/WrkPlanSection2.vue"),
    'wrk-plan-section3'    : () => import("@/components/listComponents/safetyManageComponents/safetyPlan/WrkPlanSection3.vue"),
    'send-sms'             : () => import("@/components/listComponents/safetyManageComponents/safetyPlan/SendSms.vue"),
    'send-email'           : () => import("@/components/listComponents/safetyManageComponents/safetyPlan/SendMail.vue"),
    'wrk-reg-docs'         : () => import("@/components/listComponents/wrkComponents/wrkPlan/WrkRegDocs.vue"),
    'safety-wrk-risk-check': () => import("@/components/listComponents/safetyManageComponents/safetyPlan/SafetyWrkRiskCheck.vue"),
    'wrk-out-system-info'  : () => import("@/components/listComponents/wrkComponents/wrkPlan/WrkOutSystemInfo.vue"),
	  
    // 승인
	  'safety-app-list'      : () => import("@/components/listComponents/safetyManageComponents/safetyApprove/WrkAppList.vue"),
    // 수행
    'safety-conduct-check' : () => import("@/components/listComponents/safetyManageComponents/safetyFulfill/WrkConductCheck.vue"),
    'relation-incidient'   : () => import("@/components/listComponents/safetyManageComponents/safetyFulfill/RelationIncidient.vue"),
    'safety-check-regist'  : () => import("@/components/listComponents/safetyManageComponents/safetyFulfill/SafetyCheckRegist.vue"),
    'safety-check-regist2' : () => import("@/components/listComponents/safetyManageComponents/safetyFulfill/SafetyCheckRegist2.vue"),
    'safety-check-result'  : () => import("@/components/listComponents/safetyManageComponents/safetyFulfill/SafetyCheckResult.vue"),
    // 완료
    'safety-complete-list' : () => import("@/components/listComponents/safetyManageComponents/safetyComplete/safetyCompleteList.vue"),
    'wrk-reg-docs'         : () => import("@/components/listComponents/wrkComponents/wrkPlan/WrkRegDocs.vue"),
    //개통등록 통합
    'wrk-order-info-reg'   : () => import("@/components/listComponents/wrkComponents/wrkRegist/WrkOrderInfoReg.vue"),
    //인시던트등록 통합
    'wrk-incident-reg-info': () => import("@/components/listComponents/wrkComponents/wrkRegist/WrkIncidentRegInfo.vue"),
    //작업등록공통
    'wrk-regist-common'    : () => import("@/components/listComponents/safetyManageComponents/safetyRegist/WrkRegistCommon.vue"),
    //사용자정보공통
    'wrk-use-user-info'    : () => import("@/components/listComponents/safetyManageComponents/safetyRegist/WrkUseUserInfo.vue"),
    //체크리스트(QR)
    'wrk-conduct-qr-check' : () => import("@/components/listComponents/wrkComponents/wrkConduct/WrkConductQrCheck.vue"),
    //이행전용완료정보
    'wrk-complete-migrt'   : () => import("@/components/listComponents/wrkComponents/wrkComplete/WrkCompleteMigrt.vue"),
    'wrk-time-code'     : () => import("@/components/listComponents/wrkComponents/wrkConduct/WrkTimeCode.vue"),
  },
  computed: {
    calTicketInfo() {
      var ticketInfo = {};
      const ticketList = this.allTicketList; // this.$store.getters["wflowStore/getExeWflowTicketList"];
      for (var tmpTicket of ticketList) {
        if (tmpTicket.ticktId == this.ticktId) {
          ticketInfo = Object.assign({}, tmpTicket);
          break;
        }
      }
      this.targetTicketInfo = ticketInfo;
      return ticketInfo;
    },

    witchStep() {
      let ComponentInfo = {};
      this.componentJson.forEach(item => {
        if (item[0] != this.compNm) return;
        ComponentInfo = Object.assign({}, item[1]);
        // Vue.component(item[1].componentName, () => import(item[1].path));
      });

      if (Object.keys(ComponentInfo).length == 0) {
        alert('설정한 화면의 컴포넌트가 없습니다.\n(' + this.compNm + ')')
        // this.closeComponentViewerModal();
        return;
      }

      // 고객 포탈인 경우 컴포넌트 예외 처리
      //  수행 단계에서 작업수행의견 작성만 보이도록...
      if (this.stepCd == '2869') {
        if (ComponentInfo.componentName != 'wrk-common-sbst') return;
      }

      return ComponentInfo.componentName;
    }
  },
  updated() {
    if (Object.keys(this.$refs).length != 0) {
      if (this.$refs[Object.keys(this.$refs)[0]].chkValidateData) {
        this.componentStore = {
          componentTitle: this.compTitle,
          prcssTypeCd: this.prcssTypeCd,
          ticktId: this.ticktId,
          stepCd: this.stepCd,
          mainPrcssId: this.mainPrcssId,
          subPrcssId: this.subPrcssId,
          wflowScrnId: this.wflowScrnId,
          scrnId: this.scrnId,
          mandDataChkYn: this.mandDataChkYn,
        };
        this.componentStore.validateFunction = this.$refs[Object.keys(this.$refs)[0]].chkValidateData;
        // console.log('Validate Component Store')
        // console.log(this.componentStore)

        // 스토어 등록
        this.$store.commit("wflowStore/pushWrkComponentStore", this.componentStore);
      }
      else {
        console.log("Component Validate Function Check! => " + this.componentStore.componentName);
      }
    }
  },
  methods: {
    async includeRule(roleId, usrId) {
      if (roleId == null || roleId == '' || usrId == null || usrId == '') return false;

      const resultData = await this.$BIZ_SERVICE.post(this._vm.$API_URLS.Com.getUserInfoListByRoleId, {
          roleId: roleId,
          userId: usrId,
        });
      if (resultData.status == 200 && resultData.data.resData.length > 0) {
        return true;
      }

      return false;
    }
  },
};
</script>
<style lang="scss" scoped></style>